import { useEffect } from "react";

import ReactQuill from "react-quill-new";
import "react-quill-emoji/dist/quill-emoji.css";
import "react-quill-new/dist/quill.snow.css";

const modules = {
  toolbar: false,
  "emoji-textarea": true,
  "emoji-shortname": true,
  clipboard: {
    matchVisual: false,
  },
};

const QuillInput = ({ value, onChange, ...props }) => {
  useEffect(() => {
    const observer = new MutationObserver(() => {
      const picker = document.getElementById("textarea-emoji");
      if (picker) {
        picker.style.position = "absolute";
        picker.style.zIndex = "1000";
        picker.style.top = "50px"; // Adjust based on your layout
        picker.style.right = "10px"; // Adjust as needed
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  return (
    <ReactQuill
      modules={modules}
      value={value}
      onChange={onChange}
      toolbar={false}
      {...props}
    />
  );
};

export default QuillInput;
